/** biome-ignore-all lint/style/useNamingConvention: camel case */
import cx from 'classnames';
import {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import {useSelector} from 'react-redux';
import {useIsInPremiumUpsellContentVariation} from '~/CreateFabricInvitation/utils/experiments';
import {
  getEventId,
  selectEventStatus,
  selectTemplateName,
} from '~/common/fabric/reducers/eviteEvent/selectors';
import {useIsMediumAndUp} from '~library/hooks/useMatchQuery';
import {BottomSheet} from '~library/molecules/BottomSheet';
import {TrackingEvents} from '~library/shared/enums/TrackingEvents';
import {sendTrackingData} from '~library/utils/tracking';
import {UpsellModalContent, UpsellModalContentVariant} from './UpsellModalContent';

import './UpsellModal.sass';
import './HostGalleryUpsellModal.sass';

export const UpsellModal = (props) => {
  const {toggleUpsellModal, aboveOtherModals, ref} = props;
  const isMediumAndUp = useIsMediumAndUp();
  const upsellModalRef = useRef(null);

  // Experiment name: "test_premium_upsell_content" cleanup ticket: EVT-36514
  // Users who first click on any Premium upsell modals get bucketed
  const isInPremiumUpsellContentTest = useIsInPremiumUpsellContentVariation();

  const templateName = useSelector(selectTemplateName);
  const eventId = useSelector(getEventId);
  const eventStatus = useSelector(selectEventStatus);

  useEffect(() => {
    sendTrackingData(TrackingEvents.ContentLoadTracking, {
      identifier: `upsell_modal_${props.mode}`,
      attributes: {
        templateId: templateName,
        eventId: eventId,
        status: eventStatus,
      },
    });
  }, [templateName, eventId, eventStatus, props.mode]);

  useEffect(() => {
    if (!upsellModalRef.current) return;

    upsellModalRef.current.style.height = `${upsellModalRef.current.offsetHeight}px`;
  }, []);

  // TODO Refactor to use ResponsiveModal
  return createPortal(
    <div
      className={cx('create-flow__upsell-modal', {
        'create-flow__upsell-modal--above-others': aboveOtherModals,
      })}
    >
      {/* TODO: Refactor to PB Button component */}
      <button
        className="unstyled-button create-flow__upsell-modal-overlay"
        onClick={toggleUpsellModal}
        type="button"
        aria-label="Upsell modal backdrop"
      />
      {isMediumAndUp &&
        (isInPremiumUpsellContentTest ? (
          <UpsellModalContentVariant {...props} ref={ref} />
        ) : (
          <UpsellModalContent {...props} ref={ref} />
        ))}

      {!isMediumAndUp && (
        <BottomSheet
          content={<UpsellModalContent {...props} ref={ref} />}
          onClose={() => toggleUpsellModal(false)}
          aboveOtherModals
          in
        />
      )}
    </div>,
    document.body
  );
};
